<template>
    <el-select v-model="value">
      <el-option 
        v-for="item in stationData" 
        :key="item.id" 
        :value="item.id"
        :label="item.name"
      ></el-option>
    </el-select>
</template>

<script>
export default {
  name: 'Station',
  data() {
    return {
      stationData: [],
      value: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.mixin_getSelectStation().then(data => {
        this.stationData = data
      })
    }
  }
}
</script>

<style>

</style>